import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { AuthService } from './auth.service';
import { APIService } from './api.service';
import { Router } from '@angular/router';

@Injectable()
export class DonationCampaignService {

    constructor(
        public alertController: AlertController,
        private authService: AuthService,
        private router: Router,
        private apiService: APIService
    ) { }

    getDonationCampaigns(params) {
        return new Promise((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.getDonationCampaigns(params).then((donation_campaigns: any) => {
                    resolve(donation_campaigns);
                })
                .catch((error) => {
                    if(error.status === 400) {
                        this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to get the donation campaigns.");
                    }
                    else if(error.status === 403) {
                        this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to view donation campaigns.");
                    }
                    else if(error.status === 404 || error.status === 0) {
                        this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to retrieve donation campaigns at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ['OK'],
        });
        await alert.present();
    }

}
